<ng-template #aiChipTpl>
  <ng-container *ngIf="checkview && checkview.aiEnabled()">
    <span *ngIf="checkview.workspace.aiResult?.status === 'failed'" class="chip app-chip-status bg-red"
          [tooltip]="checkview.aiReasonText() + checkview.getRessource('ki.tooltipRefresh')"
          (click)="checkview.refreshAiStatus()">
      <i class="fal fa-circle-xmark app-space-right"></i>{{checkview.getRessource('ki.notProcessable')}}
    </span>
    <span *ngIf="checkview.workspace.aiResult?.status === 'conflict'" class="chip app-chip-status bg-yellow"
          [tooltip]="checkview.aiReasonText()"
          (click)="checkview.applyAiSuggestions()">
      <i class="fal fa-triangle-exclamation app-space-right"></i>{{checkview.getRessource('ki.conflict')}}
    </span>

    <span *ngIf="checkview.workspace.aiResult?.status === 'available'" class="chip app-chip-status bg-green"
          [tooltip]="checkview.getRessource('ki.tooltipApplyAvailable')"
          (click)="checkview.applyAiSuggestions()">
      {{checkview.getRessource('ki.available')}}
    </span>

    <span *ngIf="!checkview.workspace.aiResult?.status &&
                 (checkview.workspace.aiQueue?.kiqStatus === 'failed' ||
                  checkview.workspace.aiQueue?.kiqStatus === 'failedApiCall')"

          class="chip app-chip-status bg-red"
          [tooltip]="checkview.workspace.aiQueue.kiqStatus + checkview.getRessource('ki.tooltipRefresh')"
          (click)="checkview.refreshAiStatus()">
      <i class="fal fa-circle-xmark app-space-right"></i>{{checkview.getRessource('ki.error')}}
    </span>

    <span *ngIf="!checkview.workspace.aiResult?.status &&
                 checkview.workspace.aiQueue?.kiqStatus &&
                 checkview.workspace.aiQueue?.kiqStatus !==
                 'failed' && checkview.workspace.aiQueue?.kiqStatus !==
                 'failedApiCall'"
          class="chip app-chip-status bg-yellow"
          [tooltip]="checkview.workspace.aiQueue.kiqStatus + checkview.getRessource('ki.tooltipRefresh')"
          (click)="checkview.refreshAiStatus()">
      <i class="far fa-spinner-third fa-spin app-space-right"></i>{{checkview.getRessource('ki.running')}}
    </span>
    <i *ngIf="checkview.aiProcessingComment()"
       class="fal fa-circle-info app-space-left typo-small"
       style="cursor: help"
       [title]="checkview.aiProcessingComment()"></i>
  </ng-container>
</ng-template>

<div class="layout-auto-1-auto" style="position:relative">
  <div *ngIf="checkview?.aiRunning()" class="absolute-spinner">
    <div class="stack-center">
      <i class="far fa-spinner-third fa-spin c-blue fa-3x"></i>
      <span class="chip app-chip-status app-space-top_1">{{checkview.aiStageText()}}</span>
      <button *ngIf="!checkview.aiFinishing" class="md-btn-solid app-space-top_1"
              (click)="checkview.aiEditManually()">
        {{checkview.getRessource('ki.editManually')}}
      </button>
    </div>
  </div>
  <ng-container *ngIf="(checkview && !checkview?.workspace.isLoading) || !checkview">
    <div *ngIf="receipt && !visibilityController.companyForm" class="app-space-left">
      <!--Receipt-->
      <ng-container *ngIf="!receiptEditMode">
        <div class="grid-1-auto app-space-top">
          <h2 class="app-space-left">
            <i [ngClass]="getRessource('Icon')"
               class="app-space-right">
            </i>
            {{getGlobal('Receipt') + ' ' + (receipt?.rcptNumber ? '- ' + receipt?.rcptNumber : '')}}
            <i class="far fa-exclamation-triangle c-yellow"
               *ngIf="checkview && checkview.workspace.duplicates.length > 0 && excSecurity.isFeatured('RECEIPTCHECKDUPL')"
               [tooltip]="getRessource('checkDuplicates')"
               (click)="checkview.showModalReceiptCheckDuplicate()">
            </i>
          </h2>
          <div class="typo-small typo-right app-space-right app-space-top">
            <em>
              {{enumSvc.getEnumerationText('ReceiptStatus', receipt?.rcpt_enmIdent_ReceiptStatus)}}
            </em>
            <em>
              {{enumSvc.getEnumerationText('ReceiptType', receipt?.rcpt_enmIdent_ReceiptType)}}
            </em>
          </div>
        </div>
        <div class="app-space-left">
          <ng-container *ngTemplateOutlet="aiChipTpl"></ng-container>
        </div>
        <div class="spawn-reverse typo-right app-space-right">
          <em class="app-space-bottom">
            <strong>{{receipt?.rcptDate | excDate}}</strong><br>
          </em>
        </div>
        <div class="grid-auto-1-auto-start">
          <app-company #VCCompany
			                 [CompanyData]="CompanyData"
			                 [canChangeView]="canChangeEditMode"
			                 [checkview]="checkview"
			                 [editMode]="false"
			                 [showCompanyForm]="false">
          </app-company>
          <div></div>
          <div class="app-typo-container-s-q-s typo-small spawn-reverse ">
            <span>{{enumSvc.getFieldCaption("Receipt", "rcptNetSum")}}:</span>
            <q></q>
            <span class="typo-right">
              {{receipt.rcptNetSum | excCurrency:'€'}}
            </span>
            <span>
              {{getTranslation('MwSt.') + '&nbsp;[' + receipt?.rcptVATRate + '%]'}}
            </span>
            <q></q>
            <span class="typo-right">
              {{calcVAT(0, false) | excCurrency:'€'}}
            </span>
            <span>{{enumSvc.getFieldCaption("Receipt", "rcptGrossSum")}}:</span>
            <q></q>
            <span class="typo-right">
              <strong>
                {{receipt.rcptGrossSum | excCurrency:'€'}}
              </strong>
            </span>
          </div>
        </div>
        <div class="span-2 app-textarea app-space-left ">
	        <h4 class="typo-small">
            {{enumSvc.getFieldCaption("Receipt", "rcptObject")}}
          </h4>
	        <div style="margin-left: 0.75rem">
	          <span *ngFor="let o of rcptObjectList"
                  class="chip"
                  style="padding-right: 0.7em">
              {{o.enmText}}
            </span>
	        </div>
	        <h4 class="typo-small">{{enumSvc.getFieldCaption("Receipt", "rcptDesc")}}:</h4>
	        <p (dblclick)="expand = !expand"
	           [innerText]="receipt?.rcptDesc"
	           [class.height-auto-fit]="!expand"
	           [class.height-basic]="expand"
	           class="md-textarea app-space-right app-space-left typo-small content app-space-top_1">
	        </p>
        </div>
      </ng-container>
      <!--Receipt-->
      <!--Receipt-Form-->
      <ng-container *ngIf="receiptClone && receiptEditMode  && canChangeEditMode">
        <div class="grid-1-auto app-space-top">
          <h2 class="app-space-left">
            <i [ngClass]="getRessource('Icon')"
               class="app-space-right">
            </i>
            {{getGlobal('Receipt') + '&nbsp;' + (receiptClone?.rcptNumber ? '-&nbsp;' + receiptClone?.rcptNumber : '')}}
          </h2>
          <div class="typo-small typo-right app-space-right">
            <em>
              {{enumSvc.getEnumerationText('ReceiptStatus', receiptClone?.rcpt_enmIdent_ReceiptStatus)}}
            </em>
          </div>
        </div>
        <div class="app-space-left">
          <ng-container *ngTemplateOutlet="aiChipTpl"></ng-container>
        </div>
        <form #modalReceipt="ngForm" *ngIf="receiptEditMode" class="modal-form app-space-right">
          <div class="grid cols-2 typo-small">
            <exg-input [(ngModel)]="receiptClone.rcptDate" #VCDate
                       [caption]="enumSvc.getFieldCaption('Receipt','rcptDate')"
                       name="rcptDate" type="date" [isEpoch]="true">
            </exg-input>
            <exg-select #VCrcptTyp *ngIf="rcpt_enmIdent_ReceiptTypeList.length >= 0"
                        [(ngModel)]="receiptClone.rcpt_enmIdent_ReceiptType"
                        [caption]="enumSvc.getFieldCaption('Receipt','rcpt_enmIdent_ReceiptType')"
                        [list]="rcpt_enmIdent_ReceiptTypeList"
                        (focusout)="Events?.Receipt?.Checkview?.CheckDuplicates?.emit()"
                        listdisplay="enmText" name="type"></exg-select>
            <exg-input [(ngModel)]="receiptClone.rcptNumber" #VCNumber
                       [caption]="enumSvc.getFieldCaption('Receipt','rcptNumber')"
                       (focusout)="Events?.Receipt?.Checkview?.CheckDuplicates?.emit()"
                       name="R.No." type="text" class="span-2">
            </exg-input>

            <div class="span-2 grid-1-auto">
              <h3 class="typo-small"
                  (click)="openObjectEditor()">
                {{enumSvc.getFieldCaption('Receipt','rcptObject')}}
              </h3>
              <div (click)="openObjectEditor()" style="cursor: pointer">
                <i class="fa-duotone fa-list app-space-right_075"></i>
              </div>
              <div style="margin-left: 0.75rem"
                   class="span-2">
                <exg-chips [list]="rcptObjectList"
                           listdisplay="enmText"
                           (ItemClose)="chipClose_resetObject($event.item)">
                </exg-chips>
              </div>
            </div>

            <app-textarea-input [value]="receiptClone.rcptDesc" #VCDesc class="span-2"
                                [caption]="enumSvc.getFieldCaption('Receipt','rcptDesc')">
            </app-textarea-input>
            <exg-checkbox (ngModelChange)="taxValueChanged()" [(ngModel)]="taxVisible"
                          [caption]="getRessource('Form.TaxField.UseTax')"
                          class="span-2 typo-small" name="taxVisibleswitch">
            </exg-checkbox>
            <div class="typo-right">
              <exg-input #rcptBrutto
                         (ngModelChange)="calcRcptBrutto($event, receiptClone.rcptVATRate)"
                         [ngModel]="receiptClone.rcptNetSum"
                         [caption]="taxVisible ? enumSvc.getFieldCaption('Receipt','rcptNetSum') :
                         getRessource('Rechnungsbetrag')" [step]="0.01"
                         name="rcptBrutto" type="number">
              </exg-input>
	            <exg-input #rcptNetto
                         [(ngModel)]="receiptClone.rcptGrossSum"
	                       [caption]="enumSvc.getFieldCaption('Receipt','rcptGrossSum')"
                         [hidden]="!taxVisible"
                         [step]="0.01"
	                       name="rcptNetto" type="number">
	            </exg-input>
            </div>
            <exg-input #rcptVATRate *ngIf="taxVisible"
                       [ngModel]="receiptClone.rcptVATRate"
                       (ngModelChange)="calcRcptBrutto(receiptClone.rcptNetSum, $event)"
                       [caption]="enumSvc.getFieldCaption('Receipt','rcptVATRate')"
                       [hintText]="getRessource('Form.TaxField.HintText')"
                       [max]="100"
                       [min]="0" [step]="0.1" name="rcptVATRate" type="number">
            </exg-input>
            <div *ngIf="!taxVisible"></div>
	          <div class="span-2 search-filter-seperator app-space-top"></div>

            <h3 class="span-2">
              <i [class.far]="!CompanyData?.compID"
                 [class.fas]="CompanyData?.compID"
                 class="fa-building">
              </i> {{enumSvc.getFieldCaption('Receipt', 'rcptComp')}}
            </h3>
            <!--Company -->
            <app-company *ngIf="!checkview.aiIssuerPending()"
                         [checkview]="checkview"
                         [CompanyData]="CompanyData"
                         [editMode]="canChangeEditMode"
                         [showCompanyForm]="false">
            </app-company>
            <!-- Company -->
            <div *ngIf="!checkview.aiIssuerPending()"
                 class="typo-container-q-s-s typo-small app-place-baseline">
              <q></q>
              <span class="">
                <i (click)="checkview.receiptChooseCompany()"
                   [tooltip]="'Suche Firma'"
                   class="far fa-search md-btn-circular" flow="left"></i>
              </span>
              <span (click)="checkview.receiptChooseCompany()"
                    [tooltip]="'Suche Firma'"
                    class="app-cursor-pointer">
                {{getRessource('Aussteller', {add: 'suchen'})}}
              </span>
              <q></q>
              <span class="app-space-top">
                <i (click)="visibilityController.companySwitch()"
                   [tooltip]="getRessource('Aussteller',
                    {add: CompanyData?.compID ? getGlobal('edit') : getGlobal('create')})"
                   [class.far]="!CompanyData?.compID"
                   [class.fas]="CompanyData?.compID"
                   class="fa-building md-btn-circular" flow="left"></i>
              </span>
              <span (click)="visibilityController.companySwitch()"
                    [tooltip]="getRessource('Aussteller',
                    {add: CompanyData?.compID ? getGlobal('edit') : getGlobal('create')})"
                    class="app-space-top app-cursor-pointer">
                {{getRessource('Aussteller'
                , {add: CompanyData?.compID ? getGlobal('edit') : getGlobal('create')})
                }}
              </span>
              <q></q>
              <span class="">
                <i (click)="checkview.receiptUnlinkCompany(CompanyData?.compID)"
                   [tooltip]="getRessource('Zuordnung') + ' ' + getRessource('entfernen')"
                   [class.disabled]="!CompanyData?.compID"
                   class="search-filter-action far fa-unlink" flow="left">
                </i>
              </span>
              <span (click)="checkview.receiptUnlinkCompany(CompanyData?.compID)"
                    [tooltip]="getRessource('Zuordnung') + ' ' + getRessource('entfernen')"
                    class="app-cursor-pointer">
                {{getRessource('Zuordnung')}} {{getRessource('entfernen')}}
              </span>
            </div>
            <div *ngIf="checkview.aiIssuerHasMismatch() && !checkview.aiSupplementMode"
                 class="span-2 bg-yellow typo-small app-cursor-pointer"
                 style="padding: 0.5rem; border-radius: 0.5rem; margin: 0.5rem 1rem"
                 (click)="checkview.openAiIssuerSupplement()">
              {{checkview.getRessource('ki.issuerUpdate')}}
            </div>
            <div *ngIf="checkview.aiIssuerPending() && !checkview.aiSupplementMode"
                 class="span-2 typo-container-q-s-s typo-small app-place-baseline app-space-top">
              <span>
                {{checkview.aiIssuerSuggestion ? checkview.getRessource('ki.issuerFound')
                : checkview.getRessource('ki.issuerNew')}}
                <strong>
                  {{checkview.aiIssuerName()}}
                </strong>
              </span>
              <span class="chip app-chip-status bg-green"
                    [tooltip]="checkview.getRessource('ki.issuerApplyTooltip')"
                    (click)="checkview.acceptAiIssuer()">
                <i class="fal fa-check app-space-right"></i>
                {{checkview.aiIssuerSuggestion ? checkview.getRessource('ki.issuerApply')
                : checkview.getRessource('ki.issuerCreate')}}
              </span>
              <span class="chip app-chip-status bg-red"
                    (click)="checkview.rejectAiIssuer()">
                <i class="fal fa-xmark app-space-right"></i>
                {{checkview.getRessource('ki.issuerReject')}}
              </span>
            </div>
            <ng-container *ngIf="CompanyData?.compID">
              <div class="span-2 search-filter-seperator app-space-top"></div>
              <h3 class="span-2">
                <i [class.fas]="checkview.workspace.companyLinkData && checkview.workspace.companyLinkData.length > 0"
                   [class.far]="checkview.workspace.companyLinkData && checkview.workspace.companyLinkData.length === 0"
                   class="fa-building">
                </i> {{getRessource('SubCompany')}}
              </h3>
              <div>
                <ng-container *ngFor="let subCompany of checkview.workspace.companyLinkData">
                  <!--Sub Company -->
                  <div class="grid-1-auto">
                    <app-company [checkview]="checkview"
                                 [CompanyData]="subCompany"
                                 [editMode]="canChangeEditMode"
                                 [showCompanyForm]="false">
                    </app-company>
                    <span class="" style="width: 2rem">
                      <i (click)="visibilityController.companySwitch(true, subCompany?.compID)"
                         [tooltip]="getRessource('SubCompany') + ' ' + getGlobal('edit')"
                         class="search-filter-action far fa-pencil" flow="right">
                      </i>
                      <i (click)="checkview.receiptCompanyLinkD(subCompany?.compID)"
                         [tooltip]="getRessource('Zuordnung') + ' ' + getRessource('entfernen')"
                         class="search-filter-action far fa-unlink" flow="right">
                      </i>
                    </span>
                  </div>
                  <!--Sub Company -->
                </ng-container>
              </div>
              <div class="typo-container-q-s-s typo-small app-place-baseline">
                <q></q>
                <span class="">
                  <i (click)="checkview.receiptChooseCompany(true)"
                     [tooltip]="getRessource('SearchSubCompany')"
                     [class.disabled]="!CompanyData?.compID"
                     class="search-filter-action far fa-magnifying-glass" flow="left">
                  </i>
                </span>
                <span (click)="checkview.receiptChooseCompany(true)"
                      [tooltip]="getRessource('SearchSubCompany')"
                      class="app-cursor-pointer">
                  {{getRessource('SearchSubCompany')}}
                </span>
                <q></q>
                <span class="">
                  <i (click)="visibilityController.companySwitch(true)"
                     [tooltip]="getRessource('CreateSubCompany')"
                     class="search-filter-action far fa-diagram-next" flow="left">
                  </i>
                </span>
                <span (click)="visibilityController.companySwitch(true)"
                      [tooltip]="getRessource('CreateSubCompany')"
                      class="app-cursor-pointer">
                  {{getRessource('CreateSubCompany')}}
                </span>
              </div>
            </ng-container>
          </div>
        </form>
      </ng-container>
      <div class="search-filter-seperator app-space-right"></div>
      <!--Receipt-Form-->
      <!--Receipt-->
    </div>
    <!--Company-Form -->
    <ng-container *ngIf="visibilityController?.companyForm">
      <div *ngIf="checkview &&
                  checkview.aiSupplementMode &&
                  checkview.aiSupplementFields.length > 0"
           class="bg-yellow typo-small"
           style="padding: 0.5rem; border-radius: 0.5rem; margin: 0.5rem 1rem">
        {{checkview.getRessource('ki.issuerSupplemented')}}:
        <strong>
          {{checkview.aiSupplementFields.join(', ')}}
        </strong>
      </div>
      <app-company #VCcompanyForm
                   [CompanyData]="CompanyData"
                   [checkview]="checkview"
                   [compToRcpt]="!visibilityController.companyLink"
                   [compLinkRcpt]="visibilityController.companyLink"
                   [editMode]="visibilityController.companyForm"
                   [showCompanyForm]="visibilityController.companyForm">
      </app-company>
      <div class="spawn-reverse">
	      <ng-container *ngIf="VCcompanyForm.init">
          <button (click)="VCcompanyForm.companyShowDuplicates()"
                  [disabled]="!VCcompanyForm.duplicate"
                  class="md-btn">
            {{getRessource('Duplicates')}}
          </button>
        </ng-container>
        <button (click)="visibilityController.companySwitch()" class="md-btn">
          {{getGlobal('Cancel')}}
        </button>
        <button (click)="checkview.receiptCompany(VCcompanyForm.CompanyDataClone, visibilityController.companyLink)" class="md-btn"
                [disabled]="!VCcompanyForm.validate()">
          <ng-container *ngIf="VCcompanyForm.init">
            {{getGlobal('create')}}
          </ng-container>
          <ng-container *ngIf="!VCcompanyForm.init">
            {{getGlobal('Save')}}
          </ng-container>
        </button>
        <ng-container *ngIf="!visibilityController.companyLink">
          <i (click)="checkview.receiptUnlinkCompany(VCcompanyForm.CompanyDataClone?.compID)"
             [class.disabled]="VCcompanyForm.init"
             [tooltip]="'Zuordnung entfernen'"
             class="search-filter-action far fa-unlink app-space-right app-space-left app-space-bottom" flow="left">
          </i>
        </ng-container>
        <ng-container *ngIf="visibilityController.companyLink">
          <i (click)="checkview.receiptCompanyLinkD(VCcompanyForm.CompanyDataClone?.compID)"
             [class.disabled]="VCcompanyForm.init"
             [tooltip]="'Zuordnung entfernen'"
             class="search-filter-action far fa-unlink app-space-right app-space-left app-space-bottom" flow="left">
          </i>
        </ng-container>
      </div>
      <div class="search-filter-seperator app-space-right"></div>
    </ng-container>
    <!-- Company -->
    <!--Vorgang-->
    <ng-container *ngIf="details.taskDetails !== undefined">
      <div class="app-space-right app-space-left">
        <app-drawer-task-details [data]="details.taskDetails"
                                 [oeList]="details.caseOEs"
                                 [Schadenort]="details.caseLocation.data">
        </app-drawer-task-details>
      </div>
    </ng-container>
    <!--Vorgang-->
    <!-- Auftrag-->
    <ng-container *ngIf="(details.caseDetails !== undefined)">
      <div class="app-space-right search-filter-seperator">
        <app-drawer-case-details
          [data]="details.caseDetails"
          [oeList]="details.caseOEs"
          [Schadenort]="details?.caseLocation">
        </app-drawer-case-details>
      </div>
    </ng-container>
    <!--Auftrag-->
  </ng-container>
</div>
